import { InputAdornment, Button, IconButton, TableBody, TableHead, TextField, Typography } from '@mui/material';
import {
  CustomBodyCell,
  CustomHeaderCell,
  CustomTable,
  CustomTableContainer,
  CustomTableRow,
} from '@components/Styles/TableStyle';
import {
  CustomStack,
  CustomTextField,
  CustomAutocomplete,
  RequiredMark,
  RequiredMarkBox,
  SectionWrapper,
} from '@components/Styles/CommonStyle';
import { useEffect, useRef, useState, forwardRef, useImperativeHandle } from 'react';
import { useDialog } from '@context/DialogContext';
import AddIcon from '@mui/icons-material/Add';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { CustomButton } from '@components/Styles/ButtonStyle';
import 'react-datepicker/dist/react-datepicker.css';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ko from 'date-fns/locale/ko';
import DatePicker from 'react-datepicker';
import React from 'react';
import moment from 'moment';
import { theme } from '@components/Styles/theme';
import { formatAmount } from '@utils/formatter';
import api from '@api/axios';
import ProjectCreateTableInfoV2 from './ProjectCreateTableInfoV2';
import CustomInputDate from '../Input/CustomInputDate';

const ProjectCreateTableStaffV2 = forwardRef(({ getProjectInfo }, ref) => {
  const projectInfo = getProjectInfo();
  console.log('ProjectCreateTableStaffV2 :: projectInfo');
  console.log(projectInfo);

  const [searchStaff, setSearchStaff] = useState('');
  const [searchStaffList, setSearchStaffList] = useState([]);
  const [projectStaffInfo, setProjectStaffInfo] = useState([
    { seq: 1, name: '', startDate: '', endDate: '', memo: '' },
  ]);

  const { showDialog } = useDialog();

  // 프리랜서 검색
  const onSearchExternalStaff = (name) => {
    const accountType = '프리랜서';

    api
      .get(
        `/api/account/readAccountList?${accountType ? `&accountType=${accountType}` : ''}${name ? `&name=${name}` : ''}`,
      )
      .then((res) => {
        const list = res.data.result.rows;

        const externalStaffCompanyList = list.map((item) => {
          return item.person_name;
        });

        setSearchStaffList(externalStaffCompanyList);
      });
  };

  // 행 변경 함수
  const handleProjectStaffInfoChange = (event, index, field) => {
    let value = '';

    // 날짜 변경
    if (field === 'startDate' || field === 'endDate') {
      // DatePicker의 onChange에서 직접 'YYYY-MM-DD' 형식의 문자열 또는 ''을 전달받음
      value = event;
    }
    // 이외 경우
    else {
      // 값 :: 옵션 선택
      if (event?.type === 'click') {
        console.log('ProjectCreateTableStaffV2 :: option value');
        console.log(event.target.innerText);
        value = event.target.innerText;
      }
      // 값 :: 입력
      else {
        console.log('ProjectCreateTableStaffV2 :: input value');
        console.log(event.target.value);
        value = event.target.value;
      }
    }

    const updated = [...projectStaffInfo];
    updated[index][field] = value;
    setProjectStaffInfo(updated);
  };

  // 행 추가 함수
  const handleAddProjectStaffInfo = () => {
    const updated = [...projectStaffInfo];
    const newSeq = updated.length + 1;
    updated.push({ seq: newSeq, name: '', startDate: '', endDate: '', memo: '' });
    setProjectStaffInfo(updated);
  };

  // 행 삭제 함수
  const handleDeleteProjectStaffInfo = (index) => {
    showDialog({
      type: 'confirm',
      title: '확인',
      message: '정말 삭제하시겠습니까?',
      onConfirm: () => {
        const updated = [...projectStaffInfo];
        updated.splice(index, 1);
        setProjectStaffInfo(updated);
      },
    });
  };

  useImperativeHandle(ref, () => ({
    getProjectStaffInfo: () => projectStaffInfo,
    setProjectStaffInfo: (info) => setProjectStaffInfo(info),
  }));

  useEffect(() => {
    onSearchExternalStaff(searchStaff);
  }, [searchStaff]);

  return (
    <React.Fragment>
      <SectionWrapper>
        <CustomStack mb={2}>
          <Typography sx={theme.typography.h4}>인력 투입 현황</Typography>
        </CustomStack>

        <CustomTableContainer>
          <CustomTable>
            <TableHead>
              <CustomTableRow>
                <CustomHeaderCell align="center">성명</CustomHeaderCell>
                <CustomHeaderCell align="center">투입시작일</CustomHeaderCell>
                <CustomHeaderCell align="center">투입종료일</CustomHeaderCell>
                <CustomHeaderCell align="center">메모</CustomHeaderCell>
                <CustomHeaderCell align="center">관리</CustomHeaderCell>
              </CustomTableRow>
            </TableHead>
            <TableBody>
              {projectStaffInfo.map((row, index) => {
                return (
                  <CustomTableRow>
                    <CustomBodyCell>
                      <CustomAutocomplete
                        disableClearable
                        value={row.name || ''}
                        options={searchStaffList}
                        onChange={(event) => {
                          // 값 :: 옵션 선택
                          if (event?.type === 'click') {
                            setSearchStaff(event.target.innerText);
                            handleProjectStaffInfoChange(event, index, 'name');
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            value={row.name || ''}
                            onChange={(event) => {
                              // 값 :: 입력
                              setSearchStaff(event.target.value);
                              handleProjectStaffInfoChange(event, index, 'name');
                            }}
                          />
                        )}
                      />
                    </CustomBodyCell>
                    <CustomBodyCell>
                      <DatePicker
                        locale={ko}
                        selected={row.startDate ? new Date(row.startDate) : null}
                        onChange={(date) => {
                          const formattedDate = date ? moment(date).format('YYYY-MM-DD') : '';
                          handleProjectStaffInfoChange(formattedDate, index, 'startDate');
                        }}
                        dateFormat="yyyy.M.d"
                        customInput={<CustomInputDate />}
                      />
                    </CustomBodyCell>
                    <CustomBodyCell disabled={true}>
                      <DatePicker
                        locale={ko}
                        selected={row.endDate ? new Date(row.endDate) : null}
                        onChange={(date) => {
                          const formattedDate = date ? moment(date).format('YYYY-MM-DD') : '';
                          handleProjectStaffInfoChange(formattedDate, index, 'endDate');
                        }}
                        dateFormat="yyyy.M.d"
                        customInput={<CustomInputDate />}
                      />
                    </CustomBodyCell>
                    <CustomBodyCell>
                      <CustomTextField
                        value={row.memo}
                        onChange={(event) => handleProjectStaffInfoChange(event, index, 'memo')}
                      />
                    </CustomBodyCell>
                    <CustomBodyCell>
                      <CustomStack justifyContent="center">
                        <CustomButton
                          variant="outlined"
                          size="small"
                          color="error"
                          onClick={() => handleDeleteProjectStaffInfo(index)}
                        >
                          행삭제
                        </CustomButton>
                      </CustomStack>
                    </CustomBodyCell>
                  </CustomTableRow>
                );
              })}
            </TableBody>
          </CustomTable>
        </CustomTableContainer>

        <CustomStack justifyContent="end" mt={2}>
          <CustomButton variant="outlined" size="small" startIcon={<AddIcon />} onClick={handleAddProjectStaffInfo}>
            행추가
          </CustomButton>
        </CustomStack>
      </SectionWrapper>
    </React.Fragment>
  );
});

export default ProjectCreateTableStaffV2;
